import { ButtonGroup, Link, useNavigation } from '@subaio/components'
import { Form } from '@subaio/components/src/HookForm'
import { object } from '@subaio/validation'
import { Input } from '@subaio/webapp'

import { asContainer } from 'lib/container'
import { useValidation } from 'lib/useValidation'

import { ButtonSolidSubmit } from 'components/Buttons'
import { Logo } from 'components/Logo'
import { useSnackbar } from 'components/Snackbars'

import { Background } from './Background'
import { BackgroundWrapper } from './BackgroundWrapper'
import { BottomContent } from './BottomContent'
import { Grid } from './Grid'
import { SkewedContent } from './SkewedContent'
import { Subtitle } from './Subtitle'

export const container = asContainer<{}>()({
	path: '/login',
	hideHeaderAndFooter: true,
	authentication: { type: 'public' },
	Running: ({ api, setUser }) => {
		const { onUpdateUrlTo } = useNavigation()
		const { handleSnackbars } = useSnackbar()
		const { fieldEmail, fieldString } = useValidation()

		return (
			<Grid>
				<SkewedContent>
					<h1>Sign in to Subaio Finance Data</h1>
					{/* <ButtonOutline
						label={
							<ButtonLabel>
								<IconBrandGoogleFilled />
								<span>Sign in with Google</span>
							</ButtonLabel>
						}
					/> */}
					{/* <SeparatorNamed>OR</SeparatorNamed> */}
					<Form
						schema={object({ email: fieldEmail(), password: fieldString() })}
						onSubmit={handleSnackbars(
							async ({ email, password }) => {
								const { accessToken } = await api.post<{ accessToken: string }>('/auth/login', { email, password })
								setUser({ token: accessToken })
								const { billingStatus } = await api.get<{ billingStatus: string; billingUrl: string }>(
									'/billing/status',
								)
								if (billingStatus === 'ACTIVE') onUpdateUrlTo({ name: 'Home' })
								else onUpdateUrlTo({ name: 'Billing' })
							},
							{
								401: 'Invalid username and/or password',
								default: 'Failed to login',
							},
						)}
						render={() => (
							<>
								<Input name='email' label='Email' type='email' autoComplete='username' isRequired />
								<Input name='password' label='Password' type='password' autoComplete='password' isRequired />
								<ButtonGroup center>
									<ButtonSolidSubmit label='Sign in' />
								</ButtonGroup>
							</>
						)}
					/>
					<BottomContent>
						<Subtitle>
							Don't have an account? <Link name='SignUp'>Sign up</Link>
						</Subtitle>
					</BottomContent>
				</SkewedContent>
				<BackgroundWrapper>
					<Background>
						<Logo type='secondary' />
						<span>Finance Data</span>
					</Background>
				</BackgroundWrapper>
			</Grid>
		)
	},
})
